import { Grid } from "@mui/material";

const AddressDetails = (_props) => {
    const { candidateData, className } = _props
    return (
        <fieldset className={`${className}--fieldsetBox`}>
            <legend className={`${className}--legend`}>
                Address Details
            </legend>
            <fieldset className={`${className}--subFieldset toppy`}>
                <legend className={`${className}--legend`}>
                    Present Address
                </legend>
                <Grid container spacing={0}>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>Line1</p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.present_address_line1}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>Line2</p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.present_address_line2}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>
                            City / Town / Village
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.present_city}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>
                            District
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.present_district_id}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>State</p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.present_state_id}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>
                            Pincode
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.present_pincode}
                        </p>
                    </Grid>
                </Grid>
            </fieldset>
            <fieldset className={`${className}--subFieldset toppyBottom`}>
                <legend className={`${className}--legend`}>
                    Permanent Address
                </legend>
                <Grid container spacing={0}>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>Line1</p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.permanent_address_line1}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>Line2</p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.permanent_address_line2}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>
                            City / Town / Village
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.permanent_city}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>
                            District
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.permanent_district_id}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>State</p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.permanent_state_id}
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--text`}>
                            Pincode
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`dummyTxt ${className}--subText`}>
                            {candidateData?.permanent_pincode}
                        </p>
                    </Grid>
                </Grid>
            </fieldset>
        </fieldset>
    )
}

export default AddressDetails;